import type { StandardLanguageKey } from './types'

/** Labels for the standard languages */
export const LANGUAGE_LABELS = {
  bash: 'Bash',
  c: 'C',
  clojure: 'Clojure',
  cpp: 'C++',
  csharp: 'C#',
  css: 'CSS',
  curl: 'cURL',
  dart: 'Dart',
  diff: 'Diff',
  docker: 'Docker',
  dockerfile: 'Dockerfile',
  elixir: 'Elixir',
  fsharp: 'F#',
  go: 'Go',
  graphql: 'GraphQL',
  haskell: 'Haskell',
  html: 'HTML',
  http: 'HTTP',
  ini: 'INI',
  java: 'Java',
  javascript: 'JavaScript',
  json: 'JSON',
  kotlin: 'Kotlin',
  less: 'Less',
  lua: 'Lua',
  makefile: 'Makefile',
  markdown: 'Markdown',
  matlab: 'MATLAB',
  nginx: 'Nginx',
  objectivec: 'Objective-C',
  ocaml: 'OCaml',
  perl: 'Perl',
  php: 'PHP',
  plaintext: 'Plain Text',
  powershell: 'PowerShell',
  properties: 'Properties',
  python: 'Python',
  r: 'R',
  ruby: 'Ruby',
  rust: 'Rust',
  scala: 'Scala',
  scss: 'SCSS',
  shell: 'Shell',
  sql: 'SQL',
  swift: 'Swift',
  toml: 'TOML',
  typescript: 'TypeScript',
  xml: 'XML',
  yaml: 'YAML',
} as const satisfies Record<StandardLanguageKey, string>
